import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";

export function BackButton({ name, role }: { name: string; role: string }) {
  const [, navigate] = useLocation()

  return (
    <div className="flex items-center gap-4 mb-6">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => navigate("/contratual/contratos")}
        children={<ArrowLeft className="w-5 h-5" />}
      />

      <div>
        <h2 className="text-xl font-bold text-white">{name}</h2>
        <p className="text-sm text-gray-400">{role}</p>
      </div>
    </div>
  )
}